//
// Copyright (c) 2021 Astute Global, Inc.
//

import Marionette from "marionette";
import { CssTransitionDisablerMixin, View } from "ckeditor5";
import { removeCkReset } from "./ckEditorUtil";

/**
 * A specialization of the regular View that allows embedding a Marionette module.
 */
class BaseMarionetteView extends View {
  constructor(locale) {
    super(locale);
    this.region = null;
    this.module = null;
    this.set("namespace", null);
    this.setTemplate({
      tag: "div",
      attributes: {
        class: this.getClasses(),
      },
    });
  }

  createModule() {
    throw new Error("createModule must be implemented");
  }

  createRegion() {
    return new Marionette.Region({
      el: this.element,
    });
  }

  destroy() {
    if (this.module) {
      this.module.close();
      this.module = null;
    }
    if (this.region) {
      this.region.reset();
      this.region = null;
    }
    this.tearDownRequests();
    this.tearDownVents();
    super.destroy();
  }

  getClasses() {
    return ["ck", "ck-marionette-view"];
  }

  getFullName(name) {
    if (this.namespace) {
      return `${this.namespace}:${name}`;
    }
    return name;
  }

  render() {
    super.render();
    // Remove the CKEditor reset classes to avoid problems integrating with Marionette.
    // Have to wait until after it is added to its parent (and I can't find an event for that, so just doing a
    // setTimeout to delay the call).
    setTimeout(() => removeCkReset(this.element), 100);
    this.region = this.createRegion();
    this.module = this.createModule();
    this.setUpRequests();
    this.setUpVents();
    this.showModule();
  }

  showModule() {
    throw new Error("showModule must be implemented");
  }

  setUpRequests() {
    // Base class does nothing
  }

  setUpVents() {
    // Base class does nothing
  }

  tearDownRequests() {
    // Base class does nothing
  }

  tearDownVents() {
    // Base class does nothing
  }
}

const MarionetteView = CssTransitionDisablerMixin(BaseMarionetteView);

export default MarionetteView;
